// Action type strings for use in places that cannot import from actions/slice
// (e.g. syncMiddleware) due to circular dependency constraints.
// These must match the names used in createAsyncThunk / createSlice.
export const FETCH_USER_FULFILLED = "auth/fetchAndSetupUser/fulfilled";
export const RESET_USER = "auth/resetUser";
